import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum EditorPlatformBuilderServicesErrorCode {
  NotValidComponent = 'Not valid component',
}

class EditorPlatformBuilderServicesError extends BaseError<EditorPlatformBuilderServicesErrorCode> {
  constructor(message: string, code: EditorPlatformBuilderServicesErrorCode) {
    super(message, code, 'Editor Platform Components Service Error');
  }

  withComponentType(componentType: string) {
    this.state.componentType = componentType;
    return this;
  }
}

export const createEditorPlatformBuilderServicesError = createErrorBuilder<
  EditorPlatformBuilderServicesErrorCode,
  EditorPlatformBuilderServicesError
>(EditorPlatformBuilderServicesError);
